// extracted by mini-css-extract-plugin
export default {"container":"LoadingFlom_container__PbIEL","animation":"LoadingFlom_animation__ABNDd"};